import {
  SET_SELECTED_TICKET_CASE_ID,
  SET_TABLE_PAGE,
} from "../Types/TicketTypes";

const ticketState = {
  selectedTicketCaseID: null,
  tablePage: 0,
};

export const ticketReducer = (state = ticketState, action) => {
  const { payload, type } = action;

  if (type === SET_SELECTED_TICKET_CASE_ID) {
    return {
      ...state,
      selectedTicketCaseID: payload,
    };
  }

  if (type === SET_TABLE_PAGE) {
    return {
      ...state,
      tablePage: payload.tablePage,
    };
  }

  return state;
};
